import PropTypes from 'prop-types';
import { h } from 'preact';

import Wrapper from '../../1-foundation/wrapper/wrapper';
import BannerMarketing from '../../3-molecules/banner-marketing/banner-marketing';
import SectionDivider from '../../3-molecules/section-divider/section-divider';
import { modifierList } from '../../3-molecules/banner-marketing/props-list';
import { modifierList as iconModifierList } from '../../1-foundation/icons/props-list';
import { modifierList as sectionDividerModifierList } from '../../3-molecules/section-divider/props-list';

const SlimBanner = ({
  href = '#',
  modifiers = [],
  target = '_self',
  isWrapping,
  onClick,
  onClose,
  sectionDividerModifiers = [],
  imgSrc = '',
  text = '',
  iconsColor,
}) => (
  <Wrapper
    tag="a"
    href={href}
    target={target}
    isWrapping={isWrapping}
    onClick={onClick}
    role="button"
    aria-label={text}
  >
    <SectionDivider modifiers={sectionDividerModifiers}>
      <div className="l-inner-grid">
        <div className="l-inner-grid__main">
          <BannerMarketing
            imgSrc={imgSrc}
            text={text}
            modifiers={modifiers}
            onClose={onClose}
            showArrowIcon
            iconsColor={iconsColor}
          />
        </div>
      </div>
    </SectionDivider>
  </Wrapper>
);

SlimBanner.propTypes = {
  href: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  target: PropTypes.string,
  isWrapping: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  sectionDividerModifiers: PropTypes.arrayOf(PropTypes.oneOf(sectionDividerModifierList)),
  imgSrc: PropTypes.string,
  text: PropTypes.string,
  iconsColor: PropTypes.oneOf(iconModifierList),
};

export default SlimBanner;
